var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 8.49967C5.88699 8.49967 4.16699 6.77967 4.16699 4.66634C4.16699 2.55301 5.88699 0.833008 8.00033 0.833008C10.1137 0.833008 11.8337 2.55301 11.8337 4.66634C11.8337 6.77967 10.1137 8.49967 8.00033 8.49967ZM8.00033 1.83301C6.44033 1.83301 5.16699 3.10634 5.16699 4.66634C5.16699 6.22634 6.44033 7.49967 8.00033 7.49967C9.56033 7.49967 10.8337 6.22634 10.8337 4.66634C10.8337 3.10634 9.56033 1.83301 8.00033 1.83301Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7268 15.1667C13.4534 15.1667 13.2268 14.94 13.2268 14.6667C13.2268 12.3667 10.8801 10.5 8.0001 10.5C5.1201 10.5 2.77344 12.3667 2.77344 14.6667C2.77344 14.94 2.54677 15.1667 2.27344 15.1667C2.0001 15.1667 1.77344 14.94 1.77344 14.6667C1.77344 11.82 4.56677 9.5 8.0001 9.5C11.4334 9.5 14.2268 11.82 14.2268 14.6667C14.2268 14.94 14.0001 15.1667 13.7268 15.1667Z",
    fill: "currentColor"
  })));
};
export default SvgUser;